function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNybbleLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.31 178.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nybble-Logo-200x200") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "79.52 110.84 67.46 90.36 79.52 69.88 103.8 69.88 115.86 90.36 103.8 110.84 79.52 110.84",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.72,84h18.56l9.12,15.48L109.28,115H90.72L81.6,99.48,90.72,84M85,74,70,99.48,85,125h30l15-25.48L115,74Z",
    transform: "translate(-8.34 -9.12)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.53 40.13 69.48 21.36 80.53 2.58 102.79 2.58 113.84 21.36 102.79 40.13 80.53 40.13",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.49,18.29h17l8.36,14.19-8.36,14.19h-17L83.13,32.48l8.36-14.19M86.25,9.12,72.5,32.48,86.25,55.84h27.5L127.5,32.48,113.75,9.12Z",
    transform: "translate(-8.34 -9.12)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.82,55.7,41.43,42.4l16.31,2.31,5.87,15.38L53,73.39,36.7,71.08,30.82,55.7M20.38,54.08l9.69,25.31L56.9,83.21l17.15-21.5L64.37,36.4,37.53,32.58Z",
    transform: "translate(-8.34 -9.12)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.22,126.45l-3.78-16.59,12-11.3,15.69,5,3.78,16.59-12,11.3-15.7-5m-7.77,7.15,25.83,8.22L60,123.22,53.89,96.41,28.06,88.19,8.34,106.79Z",
    transform: "translate(-8.34 -9.12)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18,177.3l-15.33-7.39L55.48,153.5l13.7-9.16,15.32,7.39,1.37,16.42L72.18,177.3m.74,10.53,22.53-15.07-2.24-27L68.43,133.81,45.91,148.88l2.24,27Z",
    transform: "translate(-8.34 -9.12)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.08,170l-15.34,7.38-13.68-9.17,1.38-16.41,15.34-7.37,13.68,9.16L143.08,170m8.69,6,2.27-27-22.51-15.09-24.78,11.92-2.27,27L127,187.86Z",
    transform: "translate(-8.34 -9.12)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.55,110l-3.8,16.58-15.7,5-12-11.31,3.8-16.59,15.7-5,12,11.32m10.1-3.06L172,88.27l-25.84,8.19L140,123.26l19.7,18.62,25.83-8.19Z",
    transform: "translate(-8.34 -9.12)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.63,42.46l10.6,13.31-5.9,15.38L147,73.44,136.43,60.13l5.89-15.38,16.31-2.29m3.91-9.81L135.7,36.43,126,61.74l17.13,21.51L170,79.47l9.71-25.31Z",
    transform: "translate(-8.34 -9.12)",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNybbleLogoWhite);
export default __webpack_public_path__ + "static/media/Nybble-Logo-White.1be471eef8ed48929983501bb428ec10.svg";
export { ForwardRef as ReactComponent };